import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '@colimo/colimo-ui-library';
import { filter, map, take } from 'rxjs';

export const colimindGuard: CanActivateFn = () => {

  const authenticationService = inject(AuthenticationService);

  return authenticationService.authentication.pipe(
    // wait until we get an authentication object
    filter(auth => auth !== null),
    // only evaluate once
    take(1),
    map(data => {

      if (!data?.jwt?.token) {
        return false;
      }

      try {
        const encodedPayload = data.jwt.token.split('.')[1];
        const decodedPayload = JSON.parse(atob(encodedPayload));

        const colimoActor = decodedPayload?.actors?.find(
          (actor: any) => actor.serviceType === 'colimo'
        );

        return colimoActor?.permissions?.includes('CoLiMind') ?? false;

      } catch {
        return false;
      }
    })
  );
};
